import { createContext } from "react";

const ArticleDetailContext = createContext();

export default ArticleDetailContext;
